// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__29BD0","footer":"ModalError_footer__MJvQw"};